import {
  Assignment,
  BatchReportLineItem,
  Interval,
  Location,
  MixDesignSnapshot,
  ModelObject,
} from '@cco/model';
import { SystemTags } from '@cco/model/lib/tagging/system-tags';

export interface BatchReport extends ModelObject<number> {
  sensorDataBatchRecordKey: string;
  batchTicketNo: string;
  interval: Interval;
  location: Location;
  // TODO: Add operatorId?
  assignmentId: number;
  truckId: number;
  deliverySlipId?: number;
  mixDesignSnapshot: MixDesignSnapshot;
  lineItems: BatchReportLineItem[];
  totalVolume: number;
  concreteUnitId: number;
  status?: 'MISSING_DATA' | 'READY_FOR_PROCESSING' | 'PROCESSED';

  details?: {
    assignment?: Assignment;
  };

  systemTags?: SystemTags;
}

export const batchReportComparer = (a: BatchReport, b: BatchReport) =>
  a.interval && b.interval && b.interval.end.localeCompare(a.interval.end);
